module.exports = __webpack_public_path__ + "img/added-services.884f8fb2.svg";